import React from 'react'
import { NavLink } from 'react-router-dom'
import withBreadcrumbs from 'react-router-breadcrumbs-hoc'
import styled from 'styled-components'

import ROUTES from 'components/Routes/config/routes'

const Wrapper = styled.div`
  margin: 30px 0 18px;
  font-size: 12px;
  font-weight: 500;
`

const Breadcrumbs = ({ breadcrumbs }) => (
  <Wrapper>
    {breadcrumbs.map(({ breadcrumb, match }, index) => (
      <span key={breadcrumb.key}>
        {index < breadcrumbs.length - 1 ? (
          <NavLink to={match.url}>{breadcrumb}</NavLink>
        ) : (
          <span>{breadcrumb}</span>
        )}
        {index < breadcrumbs.length - 1 && <span> &gt; </span>}
      </span>
    ))}
  </Wrapper>
)

export default withBreadcrumbs(ROUTES)(Breadcrumbs)



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/Breadcrumbs/index.js